import { Injectable, computed, inject } from '@angular/core';
import { SceneStore } from '@stores';
import { assessmentCalculation } from '../functions';
import { TaskService } from './task.service';

@Injectable({
  providedIn: 'root',
})
export class AssessmentService {
  private sceneStore = inject(SceneStore);
  private taskService = inject(TaskService);

  assessment = computed(() => {
    const calculation = assessmentCalculation(
      this.taskService.taskList,
      this.sceneStore.reportItems(),
      this.sceneStore.sceneConfig(),
    );
    return {
      score: calculation.score,
      level:
        calculation.level === 'expert'
          ? 'Expert'
          : calculation.level === 'intermediate'
            ? 'Intermediate'
            : 'Beginner',
      timeText: calculation.timeLevel
        ? this.sceneStore.assessment()['time'][calculation.timeLevel]
        : null,
      pathText: calculation.pathLevel
        ? this.sceneStore.assessment()['path'][calculation.pathLevel]
        : null,
      penaltyText: calculation.penaltyText,
      canceledText: calculation.canceledText,
    };
  });
}
